import { History } from 'history';
import { NavStateEnum } from './types';

type JsonObj = Record<string, any>;

export const navigateToPage = (history: History, url: string, props?: JsonObj) => {
  history.push(url, props);
};

export const NAVIGATION_BREAD_CRUMBS = 'NAVIGATION_BREAD_CRUMBS';
export const navigationBreadCrumbs = (breadCrumbs: any[]) => ({
  type: NAVIGATION_BREAD_CRUMBS,
  payload: {
    breadCrumbs
  }
});

export const NAVIGATION_WEB_STATE_CHANGE = 'NAVIGATION.NAVIGATION_WEB_STATE_CHANGE';
export const navigationWebStateChange = (webState: NavStateEnum) => ({
  type: NAVIGATION_WEB_STATE_CHANGE,
  payload: {
    webState
  }
});
